import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * AOD GIP export options messages (packageStorageStrategy and related).
 * Shared by AodGipE``xportOptionsForm and AodGipExportConfigInfo.
 */
export const aodGipExportMessages: Record<string, MessageDescriptor> = defineMessages({
  packageStorageStrategyLabel: {
    id: 'audit.aod.gip.export.packageStorageStrategyLabel',
    defaultMessage: 'Almacenamiento del export',
  },
  packageStorageStrategyPerRun: {
    id: 'audit.aod.gip.export.packageStorageStrategy.PER_RUN',
    defaultMessage: 'Por ejecución',
  },
  packageStorageStrategyPerRule: {
    id: 'audit.aod.gip.export.packageStorageStrategy.PER_RULE',
    defaultMessage: 'Por regla',
  },
});

export const packageStorageStrategyMessageByValue: Record<
  'PER_RUN' | 'PER_RULE',
  MessageDescriptor
> = {
  PER_RUN: aodGipExportMessages.packageStorageStrategyPerRun,
  PER_RULE: aodGipExportMessages.packageStorageStrategyPerRule,
};
